import React from 'react';

type Props = {
  setHowToSave: () => void;
};

export const SetHowToSavePopUp = ({
  setHowToSave,
}: Props): React.ReactElement => {
  return (
    <>
      <div className="max-w-80 p-4">
        <div
          className="absolute right-0 top-0 left-0 bottom-0 bg-white z-10 max-h-modal overflow-y-auto"
          style={{ opacity: '50%' }}></div>
        <div
          className="absolute right-0 top-0 left-0 bottom-0 grid z-20"
          style={{ placeItems: 'start center' }}>
          <div className="mt-10 mx-8 mb-8 p-4 rounded-lg bg-white border border-gray-400 shadow">
            <div className="text-lg font-bold text-teal-800 text-center">
              次に貯め方の設定をしましょう
            </div>
            <img
              className="w-full mt-4"
              src="/static/images/advisor/savings-accounts.svg"
              alt="積み立て画像"
            />
            <div className="text-sm text-center mt-1">
              「<span className="font-bold">貯める口座</span>
              」と「<span className="font-bold">つみたて額</span>
              」を設定すると目標がスタートします
            </div>
            <button
              className="bg-tradewell font-bold text-base text-white w-full mt-5 py-2 px-4 rounded-lg flex flex-row justify-center items-center"
              id="target_go_setting"
              onClick={setHowToSave}>
              貯め方の設定へ
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
